import React, { useCallback, useEffect, useState } from 'react';

import {
    AchatsAppDispatch,
    FACTURES_ACHATS_SLICE_NAME,
    factureAchatsFiltersToElasticQuery,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';
import { errorInvoiceIcon } from '@europrocurement/l2d-icons';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { WidgetWithAction } from '@europrocurement/l2d-modules';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';

// interne

const FacturesAvecErreursTechniques: React.FunctionComponent = function () {
    const dispatch = useDispatch<AchatsAppDispatch>();
    const navigate = useNavigate();

    const { factureAchatApi, getFactureAchat } = useAchatsService();

    const xIdSociete = useSociete();

    const [countOfInvoicesWithTechnicalError, setCountOfInvoicesWithTechnicalError] =
        useState<string>();

    useEffect(() => {
        factureAchatApi
            .getFacturesAchatsFactureAchatCollection(
                factureAchatsFiltersToElasticQuery({
                    xIdSociete,
                    search: '',
                    orders: [],
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        cloture: true,
                        syncG3: false,
                        deleted: false,
                        codesRejetsEtat: 'error',
                    },
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfInvoicesWithTechnicalError(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [factureAchatApi, xIdSociete]);

    const clearPreviousFilters = useCallback(() => {
        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/resetmainFilter`,
        });
    }, [dispatch]);

    const applyFilters = useCallback(() => {
        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/resetmainFilter`,
        });

        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/setmainFilter`,
            payload: {
                key: 'codesRejetsEtat',
                value: 'error',
            },
        });
        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/setmainFilter`,
            payload: {
                key: 'idSociete',
                value: xIdSociete,
            },
        });

        navigate(achatsViewPathResolver('listfacture'));
    }, [dispatch, navigate, xIdSociete]);

    const beforeActionCallback = useCallback(() => {
        clearPreviousFilters();
        applyFilters();
    }, [applyFilters, clearPreviousFilters]);

    const actionCallback = useCallback(async () => {
        await dispatch(getFactureAchat({}));
    }, [dispatch, getFactureAchat]);

    const onActionSuccessCallback = useCallback(() => {
        navigate(achatsViewPathResolver('listfacture'));
    }, [navigate]);

    return (
        <WidgetWithAction
            title="Factures avec erreurs techniques"
            icon={errorInvoiceIcon}
            actionMessage="Consulter"
            actionCallback={actionCallback}
            data={countOfInvoicesWithTechnicalError}
            color="error"
            beforeActionCallback={beforeActionCallback}
            onActionSuccessCallback={onActionSuccessCallback}
        />
    );
};

export default FacturesAvecErreursTechniques;
